import { Routes, Navigate } from 'react-router-dom';

// eslint-disable-next-line @nx/enforce-module-boundaries
import { createRouteCreator } from '@occc-app/routes/CampaignComponents/utils';
// eslint-disable-next-line @nx/enforce-module-boundaries
import { OfferType } from '@occc-app/offerValidationService/types';
// eslint-disable-next-line @nx/enforce-module-boundaries
import { SentryRoute as Route } from '@occc-app/App/sentry';
// eslint-disable-next-line @nx/enforce-module-boundaries
import { ProtectedRoute } from '@occc-app/App/routes/ProtectedRoute';
// eslint-disable-next-line @nx/enforce-module-boundaries
import { Feature } from '@occc/utils-access-control';
import config from '@occc/config';

import { PromocodesCreateController } from './features/promocodes-create-page';
import { PromocodesConfigureController } from './features/promocodes-configure-page';
import { PromocodesUpdateController } from './features/promocodes-update-page';
import { PromocodeDetailsController } from './features/promocode-details-page';

export const routeCreator = {
  ...createRouteCreator(OfferType.Promocodes),
  promocodeDetails: (campaignId: string, campaignComponentId: string, promocodeId: string) =>
    `${routeCreator.base(campaignId)}/${campaignComponentId}/promocode/${promocodeId}/details`,
};

export const Promocodes = config.features.promocodesOffersEnabled
  ? () => (
      <Routes>
        <Route
          path='create'
          element={
            <ProtectedRoute feature={Feature.CAMPAIGN_COMPONENT_CREATE}>
              <PromocodesCreateController />
            </ProtectedRoute>
          }
        />
        <Route path=':promocodesId/configure/*' element={<PromocodesConfigureController />} />
        <Route path=':promocodesId/update/*' element={<PromocodesUpdateController />} />
        <Route
          path=':promocodesId/promocode/:promocodeId/details'
          element={<PromocodeDetailsController />}
        />
      </Routes>
    )
  : () => <Navigate to='/' />;
